module.exports = "\n<div>\n    <div v-if=\"form\">\n        <form-view :form.sync=\"form\" :options.sync=\"options\"></form-view>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/form/Widget.vue
// module id = ./node_modules/vue-html-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/form/Widget.vue
// module chunks = 54